const DisclaimerChatBlock = ({selectedLanguage, text}) => {
    return (
        <div className='flex gap-2 p-3 text-sm font-normal leading-4 rounded-br-lg items-start'>
            <img className="mt-1" src={"/Assets/Images/disclaimer_icon.svg"} />
            <div className="text-[var(--disclaimer-4)]">{text[selectedLanguage]}</div>
        </div>
    )
}

export default DisclaimerChatBlock;